<template>
    <div class="mak-koku-form">
        <el-form
            v-loading="loading"
            ref="kokuForm"
            :model="form" :rules="rules"
            label-position="top"
            label-width="120px"
            align="left">

            <el-form-item prop="adi" label="Koku Adi">
                <el-input v-model="form.adi" maxlength="255" minlength="1" type="text"></el-input>
            </el-form-item>
            <el-form-item prop="esans" label="Koku Esans">
                <el-input v-model="form.esans" maxlength="45" minlength="1" type="text"></el-input>
            </el-form-item>
            <el-form-item prop="hacim" label="Koku Büyüklük">
                <el-input v-model="form.hacim" maxlength="45" minlength="1" type="text"></el-input>
            </el-form-item>

            <el-divider/>

            <el-form-item prop="olcum_yogunluk" label="Ölçülen yoğunluk">
                <el-slider
                    v-model="form.olcum_yogunluk"
                    show-stops
                    :step="5"
                    :min="0"
                    :max="100"
                    show-input>
                </el-slider>
            </el-form-item>

            <el-form-item prop="olcum_sure" label="Ölçülen süre">
                <el-input v-model="form.olcum_sure" type="number"></el-input>
            </el-form-item>

            <el-form-item prop="olcum_harcanan" label="Ölçülen harcanan ml.">
                <el-input v-model="form.olcum_harcanan" type="number"></el-input>
            </el-form-item>

        </el-form>

        <el-row type="flex" justify="center">
            <el-button type="primary" @click="submit">Kaydet</el-button>
        </el-row>
    </div>
</template>

<script>
export default {
    name: 'mak-koku-form',
    props: {
        visible: {type: Boolean},
        koku: {type: Object, default: null},
    },
    data() {
        return {
            loading: false,
            timeValue: [
                new Date(2020,1, 1, 8, 30),
                new Date(2020,1, 1, 18, 30),
            ],
            form: {
                adi: null,
                esans: null,
                hacim: null,
                olcum_yogunluk: null,
                olcum_sure: null,
                olcum_harcanan: null,
            },
            rules: {
                adi: [{required: true, message: 'Adi gerekli', trigger: 'change'}],
                esans: [{required: true, message: 'Koku Esans gerekli', trigger: 'change'}],
                hacim: [{required: true, message: 'Büyüklük gerekli', trigger: 'change'}],
                olcum_yogunluk: [{required: false, message: 'Ölçülen yoğunluk gerekli', trigger: 'change'}],
                olcum_sure: [{required: false, message: 'Ölçülen süre gerekli', trigger: 'change'}],
                olcum_harcanan: [{required: false, message: 'Ölçülen harcanan ml. gerekli', trigger: 'change'}],
            }
        };
    },
    methods: {
        submit() {
            this.$refs.kokuForm.validate((valid) => {
                if (valid) {
                    if (!this.koku) {
                        this.create();
                    } else {
                        this.update();
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        create() {
            this.loading = true;
            this.$requests.Koku.createKoku(this.form)
                .then(() => {
                    this.$refs.kokuForm.resetFields();
                    this.$emit('success');
                })
                .catch((e) => {
                    console.error('error', e);
                })
                .then(() => {
                    this.loading = false;
                });
        },
        update() {
            let koku = Object.assign({}, this.form);
            delete koku.id;
            this.loading = true;
            this.$requests.Koku.updateKoku(this.form.id, koku)
                .then(() => {
                    this.$refs.kokuForm.resetFields();
                    this.$emit('success');
                })
                .catch((e) => {
                    console.error('error', e);
                })
                .then(() => {
                    this.loading = false;
                });
        },
    },
    mounted() {
        if (this.visible && this.koku) {
            this.form = Object.assign({}, this.koku);
        }
    },
    watch: {
        visible() {
            if (this.visible && this.koku) {
                this.form = Object.assign({}, this.koku);
            }
        },
    },
}
</script>

<style lang="scss">
    .mak-koku-form {
        .el-dialog__title {
            font-size: 22px;
            font-weight: bold;
        }

        .el-form-item__label {
            font-size: 16px;
            font-weight: bold;
        }

        .el-input__inner {
            font-size: 16px;

            &[type=number] {
                width: 100%;
            }
        }
    }
</style>
